import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import myAxios from '../../../../lib/axios';


const initialState = {
    data: [],
};

export const fetchPartner = createAsyncThunk(
    'masters/fetchPartner',
    async (query) => {
        try {
            const response = await myAxios.get(`/masters/partner`);
            return { success: true, message: "Partners fetched successfully!", data: response?.data?.partners };
        } catch (error) {
            if (error?.response?.data) {
                return { success: false, message: error?.response?.data?.message };
            } else {
                return { success: false, message: 'Sorry, something went wrong!' };
            }
        }
    },
);

export const createPartner = createAsyncThunk(
    'masters/createPartner',
    async (data) => {
        try {
            const response = await myAxios.post(`/masters/partner`,  data?.formData);

            return { success: true, message: "Partner added successfully!", data: response?.data };
        } catch (error) {
            if (error?.response?.data) {
                return { success: false, message: error?.response?.data?.message };
            } else {
                return { success: false, message: 'Sorry, something went wrong!' };
            }
        }
    },
);

export const updatePartner = createAsyncThunk(
    'masters/updatePartner',
    async (data) => {        
        try {
            const response = await myAxios.put(`/masters/partner/${data?.query?.partnerId}`, data?.formData);
            return { success: true, message: "Partner updated successfully!", data: response?.data };
        } catch (error) {
            if (error?.response?.data) {
                return { success: false, message: error?.response?.data?.message };
            } else {
                return { success: false, message: 'Sorry, something went wrong!' };
            }
        }
    },
);

export const deletePartner = createAsyncThunk(
    'masters/deletePartner',
    async (query) => {
        try {
            const response = await myAxios.delete(`/masters/partner/${query.partnerId}`);
            return { success: true, message: "Partner deleted successfully!", data: response?.data };
        } catch (error) {
            if (error?.response?.data) {
                return { success: false, message: error?.response?.data?.message };
            } else {
                return { success: false, message: 'Sorry, something went wrong!' };
            }
        }
    },
);



const partnerSlice = createSlice({
    name: 'partner',
    initialState,
    reducers: {
        clearPartnerData: state => {
            state.data = [];
        },
        setPartnerData: (state, action) => {
            state.data = action.payload;
        },
       
    },
});

export const partnerReducer = partnerSlice.reducer;
export const { clearPartnerData, setPartnerData } =partnerSlice.actions;

export const selectPartnerData = (state) => state.partner.data;
